import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=6850d541&scoped=true&"
import script from "./AdminSection.vue?vue&type=script&lang=ts&"
export * from "./AdminSection.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=6850d541&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6850d541",
  null
  
)

export default component.exports